import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import type { AxiosRequestConfig } from 'axios';
import type {
  ICreatePaymentHandle,
  ISharePaymentHandle,
  IBranchHandle,
  ICreateBranchHandle,
  IUpdateBranchHandle,
  IChangePaymentHandleStatus,
  IPaymentHandleConfig,
  IUpdatePaymentHandleSettings,
  IUpdatePaymentHandleName
} from '@app/dashboard/types/innerLayout/payme';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  allow403?: boolean;
};

export const createPaymentHandle = ({ handle_name }: ICreatePaymentHandle) => {
  return axiosPrivate.post(`/dashboard/v1/payment-handle`, {
    handle_name,
  });
};

export const sharePaymentHandle = ({
  share_with,
  handle_name,
  branch,
}: ISharePaymentHandle) => {
  return axiosPrivate.post(`/dashboard/v1/payment-handle/share`, {
    share_with,
    handle_name,
    ...(branch && { branch }),
  });
};

export const getBranchHandles = () => {
  return axiosPrivate.get<IBranchHandle[]>(`/dashboard/v1/branch-handle`);
};

export const createBranchHandle = ({ name }: ICreateBranchHandle) => {
  return axiosPrivate.post(`/dashboard/v1/branch-handle`, {
    name,
  });
};

export const updateBranchHandle = ({
  id,
  name,
  is_active,
}: IUpdateBranchHandle) => {
  return axiosPrivate.patch(`/dashboard/v1/branch-handle/${id}`, {
    ...(name !== undefined && { name }),
    ...(is_active !== undefined && { is_active }),
  });
};

export const changePaymentHandleStatus = ({
  handle_name,
  activate,
}: IChangePaymentHandleStatus) => {
  return axiosPrivate.patch(`/dashboard/v1/payment-handle/change-status`, {
    handle_name,
    activate,
  });
};

export const getPaymentHandleConfig = () => {
  const config = { allow403: true } as CustomAxiosRequestConfig;

  return axiosPrivate.get<IPaymentHandleConfig[]>(
    `/dashboard/v1/payment-handle`,
    config
  );
};

export const updatePaymentHandleSettings = ({
  handle_name,
  ...settings
}: IUpdatePaymentHandleSettings) => {
  return axiosPrivate.patch(`/dashboard/v1/payment-handle/${handle_name}`, {
    ...settings,
  });
};

export const updatePaymentHandleName = ({
  currentHandleName,
  newHandleName,
}: IUpdatePaymentHandleName) => {
  return axiosPrivate.patch(
    `/dashboard/v1/payment-handle/${currentHandleName}`,
    {
      handle_name: newHandleName,
    }
  );
};
